import { render, staticRenderFns } from "./AlertSubscriptionsNew.vue?vue&type=template&id=255add56&"
import script from "./AlertSubscriptionsNew.vue?vue&type=script&lang=js&"
export * from "./AlertSubscriptionsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports